export function makeDescriptionTankerKey(zoneName?: string, tariff?: string): string {
  return zoneName ? `page.meta.description.${zoneName}.${tariff}` : `page.meta.description.${tariff}`
}
